import { get, getPaginated, post, remove } from '@/api/base'

const routeEventsApi = {
  get: async eventUuid => {
    const response = await get({
      path: `route_events/${eventUuid}`,
    })
    return response.success ? response.data.route_event : null
  },
  getAll: async params => {
    const { values } = await getPaginated({
      path: 'route_events',
      params: { ...params },
      valuePath: 'route_events',
    })

    return values
  },
  getContainers: async eventUuid => {
    const response = await get({
      path: `route_events/${eventUuid}/containers`,
    })
    return response.success ? response.data.containers : []
  },
  delete: async eventUuid => {
    return await remove({
      path: `route_events/${eventUuid}`,
    })
  },
  create: async params => {
    const response = await post({
      path: `route_events`,
      params,
    })
    return response.success ? response.data.route_event : null
  },
  createRoute: async eventUuid => {
    return await post({
      path: `route_events/${eventUuid}/routes`,
    })
  },
  getRouteStatus: async eventUuid => {
    return await get({
      path: `route_events/${eventUuid}/status`,
    })
  },
}

export default routeEventsApi
